var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5492 2.53275C11.3872 1.82575 12.6128 1.82575 13.4508 2.53275L20.2008 8.22729C20.7076 8.6548 21 9.28405 21 9.94704V19.75C21 20.7165 20.2165 21.5 19.25 21.5H16.25C15.2835 21.5 14.5 20.7165 14.5 19.75V14.75C14.5 14.3358 14.1642 14 13.75 14H10.25C9.83579 14 9.5 14.3358 9.5 14.75V19.75C9.5 20.7165 8.7165 21.5 7.75 21.5H4.75C3.7835 21.5 3 20.7165 3 19.75V9.94704C3 9.28405 3.29241 8.6548 3.79916 8.22729L10.5492 2.53275Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0a6de6e0f2ba45b9e170460e74a6de1b.svg";
export { ForwardRef as ReactComponent };